import React from 'react'
import { Link } from 'react-router-dom'
import { Record, RecordStatus } from '../../../models'
import { PaginatedTableCallbacks, PaginatedTableContract } from '../../common'
import { getAuthUser } from '../../../helpers'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../../common'

interface RecordsPaidTableProps extends PaginatedTableContract {
    resources: {
        records: Record[]
    }
    callbacks: PaginatedTableCallbacks
}

export const RecordsPaidTable = (props: RecordsPaidTableProps) => {
    const { resources } = props
    const { records } = resources
    const ability = defineAbilityFor(getAuthUser())

    if (!ability.can('View', 'RefundRecord')) {
        return <InsufficientPermissions />
    }

    return (
        <table className="table">
            <tbody>
                <tr>
                    <th>Record ID</th>
                    <th>Status</th>
                    <th>Agency</th>
                    <th>Phone</th>
                    <th>Guest First Name</th>
                    <th>Guest Last Name</th>
                    <th>Confirmation Number</th>
                    <th>Paid Date</th>
                    <th>Action</th>
                </tr>
                {records.map((record) => {
                    const isRefunded = record.status.code === RecordStatus.REFUND

                    return (
                        <tr key={record.id}>
                            <td>
                                <Link to={`/records/${record.id}`}>{record.id}</Link>
                            </td>
                            <td>{record.status.name}</td>
                            <td>
                                <Link
                                    to={`/agencies/${record.agency.id}`}
                                    className="text-nowrap"
                                >
                                    {record.agency.name}
                                </Link>
                            </td>
                            <td>{record.phone}</td>
                            <td>{record.guestFirstName}</td>
                            <td>{record.guestLastName}</td>
                            <td>{record.confirmationNumber}</td>
                            <td>
                                {record.dateProcessed
                                    ? record.dateProcessed.format('M/D/YYYY')
                                    : 'N/A'}
                            </td>
                            <td>
                                {!isRefunded ? (
                                    <Link
                                        to={`/records/refund/${record.id}`}
                                        className="btn btn-primary"
                                    >
                                        Refund
                                    </Link>
                                ) : (
                                    <div className="flex items-center gap-2">
                                        <Link
                                            to={`/records/refund/view/${record.id}`}
                                            className="btn btn-sm btn-secondary"
                                        >
                                            Refunded
                                        </Link>
                                    </div>
                                )}
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}
